.container {
    margin: 0 auto;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.tableContainer {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.tableContainer table th {
    /*padding: 0 !important;*/
    background: var(--static-background-standard);
    /* padding: 14px 16px; */
    
}

.tableContainer table td {
    /* padding: 0 !important; */
    background-color: var(--static-background-standard);
    padding: 16px
}

.tableContainer table th div {
    /*padding: 0 !important;*/
    justify-content: left;
    
}

.tableContainer table td div {
    /*padding: 0 !important;*/
    justify-content: left;
    
}

.datePickerContainer {
    width: 100%;
    margin-left: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.heading {
    font-size: var(--fs-heading);
    color: var(--static-text-strong);
    font-weight: 500;
}

.title {
    width: 100%;
    padding: 25px 16px;
    background-color: var(--static-background-standard);
    border-radius: 12px 0px 0px 0px;
    border: 2px solid var(--static-divider-standard);
    border-bottom: 0;
    color: var(--static-text-strong)
}

@media (prefers-color-scheme: light) {
    .tableContainer table tr:nth-child(even) td {
      background-color: #FAFAFA;
    }
  
    .tableContainer table tr:nth-child(odd) td {
      background-color: #FFF;
    }
  }

.tableWrapper {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
}

.tableOverwrite {
    gap: 0 !important
}
  